export const JitPaths = {
  Activity: "activity",
  History: "history",
  McpRbac: "mcp-rbac",
  Routing: "routing",
  PreApprovals: "pre-approvals",
  Shell: "shell",
} as const;
